import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-text',
	standalone: false,
	templateUrl: './dynamic-form-input-text.component.html',
	styleUrl: './dynamic-form-input-text.component.scss'
})
export class DynamicFormInputTextComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	toControlKey = AbstractDynamicForm.toControlKey;

}
